(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerDetailPictures', {
            templateUrl: 'app/admin/flyers/flyer-detail/details-panel/pictures/flyer-detail-pictures.html',
            controller: flyerDetailPicturesController,
            bindings: {
                flyer: '<',
                isImmoContext: '<'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function flyerDetailPicturesController($rootScope, $translate, flyersConstants, systemConstants) {
        var vm = this;

        vm.flyerImagePaths = [];
        vm.blueprintImagePaths = [];
        vm.emptyImage = 'https://showkase-prod.s3.sa-east-1.amazonaws.com/assets/store-empty.png';
        vm.picturesState = flyersConstants.FLYER_DETAIL_PICTURES_STATE.PICTURES;
        vm.blueprintsState = flyersConstants.FLYER_DETAIL_PICTURES_STATE.BLUEPRINTS;
        vm.galleryDefaultState = vm.picturesState;
        vm.galleryState = vm.galleryDefaultState;

        vm.$onInit = init;
        vm.enablePicturesState = enablePicturesState;
        vm.enableBlueprintsState = enableBlueprintsState;

        function init() {
            if (vm.flyer.flyerImages && vm.flyer.flyerImages.length > 0) {
                vm.flyer.flyerImages.forEach(function (flyerImage) {
                    vm.flyerImagePaths.push({
                        id: flyerImage.id,
                        position: flyerImage.position,
                        path: getFlyerImageWithResolution(vm.flyer, systemConstants.IMAGE_RESOLUTIONS.DETAIL_PICTURE,
                            vm.flyer.flyerImages.indexOf(flyerImage))});
                })
            }

            if (vm.flyer.blueprintImages && vm.flyer.blueprintImages.length > 0) {
                vm.flyer.blueprintImages.forEach(function (blueprintImage) {
                    vm.blueprintImagePaths.push({
                        id: blueprintImage.id,
                        position: blueprintImage.position,
                        path: getFlyerBlueprintWithResolution(vm.flyer, systemConstants.IMAGE_RESOLUTIONS.DETAIL_PICTURE,
                            vm.flyer.blueprintImages.indexOf(blueprintImage))});
                })
            }

            var flyerType;
            if (vm.isImmoContext) {
                flyerType = $translate.instant('flyers.detail-modal.real-estate').toLowerCase();
            } else {
                flyerType = $translate.instant('flyers.detail-modal.product').toLowerCase();
            }

            vm.emptyPicturesMessage = $translate.instant('flyers.detail-modal.detail-panel.gallery.empty.pictures',
                { flyerType: flyerType });
            vm.emptyBlueprintsMessage = $translate.instant('flyers.detail-modal.detail-panel.gallery.empty.blueprints',
                { flyerType: flyerType });
        }

        function enablePicturesState() {
            vm.galleryState = vm.picturesState;
        }

        function enableBlueprintsState() {
            vm.galleryState = vm.blueprintsState;
        }
    }
})();
